import axios from "axios";
import get from "lodash/get";

import {store} from "../configureStore";
import {
    loadPluginsRequestFail,
    loadPluginsRequestStart,
    loadPluginsRequestSuccess,

    loadPluginInstallationsRequestStart,
    loadPluginInstallationsRequestSuccess,
    loadPluginInstallationsRequestFail,
} from '../actions/Plugins'


export const loadPlugins = (filters, callback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            
            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        let requestData = {
            shop_id: store.getState().Shops.activeShop.id,
        };

        dispatch(loadPluginsRequestStart(requestData));

        instance.get('plugin/plugins/', {params: requestData}).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(loadPluginsRequestSuccess(response.data.result.results));
                    callback && callback(response.data.result);
                } else {
                    dispatch(loadPluginsRequestFail(response.data.errors));
                }
            },
            error => dispatch(loadPluginsRequestFail(`Errors: ${get(error, 'response.data.errors')}`)),
        );
    };
};


export const loadPluginInstallations = (filters, callback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            
            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        let requestData = {
            shop_id: store.getState().Shops.activeShop.id,
        };

        dispatch(loadPluginInstallationsRequestStart(requestData));

        instance.get('plugin/plugin_installations/', {params: requestData}).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(loadPluginInstallationsRequestSuccess(response.data.result.results));
                    callback && callback(response.data.result);
                } else {
                    dispatch(loadPluginInstallationsRequestFail(response.data.errors));
                }
            },
            error => dispatch(loadPluginInstallationsRequestFail(`Errors: ${get(error, 'response.data.errors')}`)),
        );
    };
};
